/* =========================================================
   MELO CART AJAX
   Wires "Add to Cart" on the product page to the existing
   right-side drawer (melo-cart-drawer.liquid), using
   Shopify's AJAX Cart API — no page navigation.
   ========================================================= */

(function () {

  // Single place to change the free-shipping threshold (in cents).
  // Exposed on window so the product page's pre-cart shipping preview
  // (single-product-description.liquid) reads the same value.
  window.MELO_FREE_SHIPPING_THRESHOLD_CENTS = window.MELO_FREE_SHIPPING_THRESHOLD_CENTS || 4000; // $40.00
  var FREE_SHIPPING_THRESHOLD_CENTS = window.MELO_FREE_SHIPPING_THRESHOLD_CENTS;

  var elements = {};

  var TRASH_ICON =
    '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M4 7h16M9.5 7V5a1.5 1.5 0 0 1 1.5-1.5h2A1.5 1.5 0 0 1 14.5 5v2M6.5 7l.7 12a2 2 0 0 0 2 1.9h5.6a2 2 0 0 0 2-1.9l.7-12" ' +
        'stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function cacheElements() {
    elements.container = document.getElementById('CartContainer');
    elements.footer = document.getElementById('MeloCartDrawerFooter');
    elements.shippingFill = document.getElementById('MeloShippingBarFill');
    elements.shippingMessage = document.getElementById('MeloShippingMessage');
    elements.subtotal = document.getElementById('MeloCartSubtotal');
    elements.upsell = document.getElementById('MeloCartUpsell');
  }

  // The 30-strip-pack and 60-strip-pack variants are the ones
  // bundle-matching discounts stack onto (2x/4x/6x... gets the price of
  // the equivalent bigger pack). Their real "original_line_price" from
  // Shopify is just quantity x unit price, which doesn't reflect the
  // bundle it's actually priced as. This mirrors the same greedy
  // breakdown used for the real discounts, but with each tier's
  // official "was" price, so the strikethrough in the cart always
  // matches the bundle picker.
  var MELO_COMPARE_TIERS_BY_VARIANT = {
    52581346017511: [ // 30-strip pack (base unit)
      { qty: 4, cents: 14299 }, // 120-strip pack "was" price
      { qty: 2, cents: 7199 },  // 60-strip pack "was" price
      { qty: 1, cents: 3599 }   // 30-strip pack "was" price
    ],
    52581346050279: [ // 60-strip pack (2x base unit)
      { qty: 2, cents: 14299 }, // 120-strip pack "was" price
      { qty: 1, cents: 7199 }   // 60-strip pack "was" price
    ],
    52581346083047: [ // 120-strip pack
      { qty: 1, cents: 14299 }  // 120-strip pack "was" price
    ]
  };

  // Every pack is added to the cart as single 30-strip boxes, so every
  // cart (any mix of packs) is priced purely by total box count through
  // the "Bundle price match" discounts. Each pack keeps its own cart
  // line via the visible "Pack" property; "_boxes" (hidden at checkout)
  // is how many boxes one pack of that line holds.
  var MELO_BASE_VARIANT_ID = '52581346017511';
  var MELO_PACKS = {
    '52581346017511': { name: '30-strip pack', boxes: 1 },
    '52581346050279': { name: '60-strip pack', boxes: 2 },
    '52581346083047': { name: '120-strip pack', boxes: 4 }
  };

  // Pack prices by box count — the same greedy tiers the product page
  // and the automatic discounts use.
  var MELO_BOX_PRICE_TIERS = [
    { boxes: 4, cents: 6999 }, // 120-strip pack price
    { boxes: 3, cents: 6499 }, // 90-strip bundle price
    { boxes: 2, cents: 4999 }, // 60-strip pack price
    { boxes: 1, cents: 2999 }  // 30-strip pack price
  ];

  function packToBoxes(formData) {
    var pack = MELO_PACKS[String(formData.get('id'))];
    if (!pack) return;

    var quantity = parseInt(formData.get('quantity'), 10) || 1;
    formData.set('id', MELO_BASE_VARIANT_ID);
    formData.set('quantity', String(quantity * pack.boxes));
    formData.set('properties[Pack]', pack.name);
    formData.set('properties[_boxes]', String(pack.boxes));
  }

  function isBoxLine(item) {
    return String(item.variant_id) === MELO_BASE_VARIANT_ID;
  }

  function boxesPerPack(item) {
    var boxes = item.properties ? parseInt(item.properties._boxes, 10) : 0;
    return boxes > 0 ? boxes : 1;
  }

  function packCount(item) {
    return Math.round(item.quantity / boxesPerPack(item));
  }

  function packLabel(item) {
    return (item.properties && item.properties.Pack) || item.variant_title;
  }

  function patternPriceCents(boxes) {
    var remaining = boxes;
    var total = 0;

    MELO_BOX_PRICE_TIERS.forEach(function (tier) {
      var count = Math.floor(remaining / tier.boxes);
      total += count * tier.cents;
      remaining -= count * tier.boxes;
    });

    return total;
  }

  // The line's own pack price (e.g. 60-strip pack = $49.99). Shopify
  // spreads the bundle discount across all box lines, so the real
  // per-line amount can be an odd number; the difference to the real
  // cart total is shown once as "bundle discount".
  function linePriceCents(item) {
    return isBoxLine(item) ? patternPriceCents(item.quantity) : item.final_line_price;
  }

  function greedyCompareAtCents(variantId, quantity) {
    var tiers = MELO_COMPARE_TIERS_BY_VARIANT[variantId];
    if (!tiers) return null;

    var remaining = quantity;
    var total = 0;

    tiers.forEach(function (tier) {
      var count = Math.floor(remaining / tier.qty);
      total += count * tier.cents;
      remaining -= count * tier.qty;
    });

    return total;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return '$' + amount;
  }

  function cartImageUrl(src, size) {
    if (!src) return '';
    return src.replace(/(\.[a-zA-Z0-9]+)(\?v=\d+)?$/, '_' + size + '$1$2');
  }

  function renderShippingBar(totalCents) {
    var remaining = FREE_SHIPPING_THRESHOLD_CENTS - totalCents;
    var percent = Math.min(100, Math.max(0, (totalCents / FREE_SHIPPING_THRESHOLD_CENTS) * 100));

    if (elements.shippingFill) {
      elements.shippingFill.style.width = percent + '%';
    }

    if (elements.shippingMessage) {
      if (remaining <= 0) {
        elements.shippingMessage.textContent = "congrats! you've unlocked free shipping! 🎉";
      } else {
        elements.shippingMessage.textContent =
          "you're " + formatMoney(remaining) + ' away from free shipping';
      }
    }
  }

  function renderUpsell(cart) {
    if (!elements.upsell) return;

    var remaining = FREE_SHIPPING_THRESHOLD_CENTS - cart.total_price;

    if (!cart.items.length || remaining <= 0) {
      elements.upsell.innerHTML = '';
      return;
    }

    // Upsells one more pack of the last item added to the cart.
    var item = cart.items[cart.items.length - 1];
    var boxes = isBoxLine(item) ? boxesPerPack(item) : 1;
    var upsellPriceCents = isBoxLine(item) ? patternPriceCents(boxes) : item.final_price;

    elements.upsell.innerHTML =
      '<button type="button" class="melo-cart-upsell"' +
        ' data-variant-id="' + item.variant_id + '"' +
        ' data-boxes="' + boxes + '"' +
        ' data-pack="' + escapeHtml(isBoxLine(item) ? packLabel(item) : '') + '">' +
        '<span class="melo-cart-upsell__label">' +
          '<span class="melo-cart-upsell__plus">+</span>' +
          'add another ' + escapeHtml(item.product_title) + ' &mdash; unlocks free shipping' +
        '</span>' +
        '<span class="melo-cart-upsell__price">' + formatMoney(upsellPriceCents) + '</span>' +
      '</button>';
  }

  function lineItemMarkup(item) {
    var imageUrl = cartImageUrl(item.image, '150x150');
    var boxLine = isBoxLine(item);
    var label = boxLine ? packLabel(item) : item.variant_title;
    var shownQuantity = boxLine ? packCount(item) : item.quantity;
    var lineCents = linePriceCents(item);

    var variantLine = '';
    if (label) {
      variantLine =
        '<div class="melo-cart-item__variant">' +
          escapeHtml(label) +
        '</div>';
    }

    var compareMarkup = '';
    var compareAtCents = item.original_line_price;
    var greedyCents = greedyCompareAtCents(item.variant_id, item.quantity);

    if (greedyCents !== null) {
      compareAtCents = greedyCents;
    }

    if (compareAtCents > lineCents) {
      compareMarkup =
        '<span class="melo-cart-item__compare-price">' +
          formatMoney(compareAtCents) +
        '</span>';
    }

    return (
      '<div class="melo-cart-item" data-line-key="' + escapeHtml(item.key) + '">' +
        '<a href="' + escapeHtml(item.url) + '" class="melo-cart-item__image">' +
          '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' +
        '</a>' +
        '<div class="melo-cart-item__info">' +
          '<div class="melo-cart-item__top-row">' +
            '<a href="' + escapeHtml(item.url) + '" class="melo-cart-item__title">' +
              escapeHtml(item.product_title) +
            '</a>' +
            '<div class="melo-cart-item__price-block">' +
              compareMarkup +
              '<span class="melo-cart-item__price">' + formatMoney(lineCents) + '</span>' +
            '</div>' +
          '</div>' +
          variantLine +
          '<div class="melo-cart-item__row">' +
            '<div class="melo-cart-item__qty" data-line-key="' + escapeHtml(item.key) + '"' +
              ' data-boxes="' + (boxLine ? boxesPerPack(item) : 1) + '">' +
              '<button type="button" class="melo-cart-item__qty-btn" data-qty-action="decrease" aria-label="Decrease quantity">-</button>' +
              '<span class="melo-cart-item__qty-value">' + shownQuantity + '</span>' +
              '<button type="button" class="melo-cart-item__qty-btn" data-qty-action="increase" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button type="button" class="melo-cart-item__remove" data-line-key="' + escapeHtml(item.key) + '" aria-label="Remove item">' +
              TRASH_ICON +
            '</button>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  var FOOTER_EXTRAS_CSS =
    '.melo-cart-code{display:flex;gap:8px;margin-bottom:8px}' +
    '.melo-cart-code__input{flex:1 1 auto;min-width:0;height:44px;padding:0 16px;border:1px solid rgba(6,57,216,.3);' +
      'border-radius:12px;font:inherit;font-size:14px;color:#071642;background:#fff;text-transform:uppercase}' +
    '.melo-cart-code__input::placeholder{text-transform:lowercase;color:#9aa3bd}' +
    '.melo-cart-code__input:focus{outline:none;border-color:var(--melo-blue)}' +
    '.melo-cart-code__btn{flex:0 0 auto;height:44px;padding:0 22px;border:0;border-radius:999px;background:var(--melo-blue);' +
      'color:#fff;font:inherit;font-size:14px;font-weight:700;text-transform:lowercase;cursor:pointer}' +
    '.melo-cart-code__btn:disabled{opacity:.6;cursor:default}' +
    '.melo-cart-code-message{margin:0 0 10px;font-size:12px;color:#d32f2f;text-transform:lowercase}' +
    '.melo-cart-code-applied{display:inline-flex;align-items:center;gap:6px;margin:0 0 12px;padding:5px 10px;border-radius:999px;' +
      'background:rgba(6,57,216,.08);color:var(--melo-blue);font-size:12px;font-weight:700}' +
    '.melo-cart-code-applied button{border:0;background:none;padding:0;color:inherit;font-size:14px;line-height:1;cursor:pointer}' +
    '.melo-cart-discount-row{font-size:14px;color:var(--melo-blue)}';

  // Discount code box, applied-code chip and the two discount rows
  // ("bundle discount", "discount (CODE)"), inserted once above the
  // subtotal row of the drawer footer.
  function ensureFooterExtras() {
    var subtotalRow = elements.subtotal ? elements.subtotal.closest('.melo-cart-subtotal') : null;
    if (!subtotalRow) return false;

    if (!document.getElementById('MeloCartFooterExtrasStyle')) {
      var style = document.createElement('style');
      style.id = 'MeloCartFooterExtrasStyle';
      style.textContent = FOOTER_EXTRAS_CSS;
      document.head.appendChild(style);
    }

    if (!document.getElementById('MeloCartCodeForm')) {
      var extras = document.createElement('div');
      extras.innerHTML =
        '<form class="melo-cart-code" id="MeloCartCodeForm" novalidate>' +
          '<input type="text" class="melo-cart-code__input" id="MeloCartCodeInput"' +
            ' placeholder="discount code" autocomplete="off" aria-label="Discount code">' +
          '<button type="submit" class="melo-cart-code__btn" id="MeloCartCodeApply">apply</button>' +
        '</form>' +
        '<p class="melo-cart-code-message" id="MeloCartCodeMessage" hidden></p>' +
        '<div id="MeloCartCodeApplied"></div>' +
        '<div class="melo-cart-subtotal melo-cart-discount-row" id="MeloCartBundleDiscount" hidden></div>' +
        '<div class="melo-cart-subtotal melo-cart-discount-row" id="MeloCartCodeDiscount" hidden></div>';

      while (extras.firstChild) {
        subtotalRow.parentNode.insertBefore(extras.firstChild, subtotalRow);
      }
    }

    return true;
  }

  function renderDiscountRow(id, label, cents) {
    var row = document.getElementById(id);
    if (!row) return;

    if (cents > 0) {
      row.innerHTML =
        '<span>' + escapeHtml(label) + '</span>' +
        '<span>&minus;' + formatMoney(cents) + '</span>';
      row.hidden = false;
    } else {
      row.innerHTML = '';
      row.hidden = true;
    }
  }

  function applicableCodes(cart) {
    return (cart.discount_codes || []).filter(function (entry) {
      return entry.applicable;
    });
  }

  function renderDiscounts(cart) {
    if (!ensureFooterExtras()) return;

    // Extra saving when the packs together hit a better box-count price
    // (e.g. 60-strip pack + 30-strip pack = the 3-box price).
    var linesCents = cart.items.reduce(function (sum, item) {
      return sum + linePriceCents(item);
    }, 0);
    renderDiscountRow('MeloCartBundleDiscount', 'bundle discount', linesCents - cart.items_subtotal_price);

    // Order-level discount codes (e.g. PRE-MELO) on top of the bundle prices.
    var codes = applicableCodes(cart);
    var codeLabel = codes.length
      ? 'discount (' + codes.map(function (entry) { return entry.code; }).join(', ') + ')'
      : 'discount';
    renderDiscountRow('MeloCartCodeDiscount', codeLabel, cart.items_subtotal_price - cart.total_price);

    var applied = document.getElementById('MeloCartCodeApplied');
    if (applied) {
      applied.innerHTML = codes.map(function (entry) {
        return (
          '<span class="melo-cart-code-applied">' +
            escapeHtml(entry.code) +
            '<button type="button" data-melo-remove-code aria-label="Remove discount code">&times;</button>' +
          '</span>'
        );
      }).join('');
    }
  }

  function showCodeMessage(message) {
    var messageEl = document.getElementById('MeloCartCodeMessage');
    if (!messageEl) return;

    messageEl.textContent = message || '';
    messageEl.hidden = !message;
  }

  function updateDiscountCode(code) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ discount: code })
    }).then(function (res) { return res.json(); });
  }

  function handleCodeSubmit(event) {
    var form = event.target.closest('#MeloCartCodeForm');
    if (!form) return;

    event.preventDefault();

    var input = document.getElementById('MeloCartCodeInput');
    var button = document.getElementById('MeloCartCodeApply');
    var code = input ? input.value.trim().toUpperCase() : '';

    if (!code) {
      showCodeMessage('enter a discount code');
      return;
    }

    if (button) button.disabled = true;
    showCodeMessage('');

    updateDiscountCode(code)
      .then(function (cart) {
        var entry = (cart.discount_codes || []).filter(function (item) {
          return item.code.toUpperCase() === code;
        })[0];

        if (entry && entry.applicable) {
          if (input) input.value = '';
          return cart;
        }

        // Unknown or not valid for this cart: take it back off so
        // checkout doesn't carry a dead code.
        showCodeMessage('"' + code + '" isn\'t a valid code for this cart');
        return updateDiscountCode('');
      })
      .then(function (cart) {
        renderCart(cart);
      })
      .catch(function () {
        showCodeMessage('could not apply the code — please try again');
      })
      .then(function () {
        if (button) button.disabled = false;
      });
  }

  function handleRemoveCodeClick(event) {
    var removeButton = event.target.closest('[data-melo-remove-code]');
    if (!removeButton) return;

    removeButton.disabled = true;
    showCodeMessage('');

    updateDiscountCode('').then(function (cart) {
      renderCart(cart);
    });
  }

  function renderCart(cart) {
    cacheElements();

    if (!elements.container) return;

    if (!cart.items.length) {
      elements.container.innerHTML =
        '<div class="melo-cart-empty">' +
          '<p>your cart is empty</p>' +
          '<a href="/" data-melo-close-cart>keep shopping</a>' +
        '</div>';

      if (elements.footer) elements.footer.hidden = true;
      if (elements.upsell) elements.upsell.innerHTML = '';
      return;
    }

    elements.container.innerHTML = cart.items.map(lineItemMarkup).join('');

    if (elements.subtotal) {
      elements.subtotal.textContent = formatMoney(cart.total_price) + ' USD';
    }

    renderDiscounts(cart);
    renderShippingBar(cart.total_price);
    renderUpsell(cart);

    if (elements.footer) elements.footer.hidden = false;
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); });
  }

  function addToCart(formData) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (data) {
          throw new Error(data.description || 'Could not add item to cart.');
        });
      }
      return res.json();
    });
  }

  function changeLine(lineKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    }).then(function (res) { return res.json(); });
  }

  function updateHeaderCartCount(count) {
    var counters = document.querySelectorAll('.bigcounter');
    counters.forEach(function (el) {
      el.textContent = count;
    });
  }

  function setAddToCartLoading(form, isLoading) {
    var button = form.querySelector('#AddToCart');
    if (!button) return;
    button.disabled = isLoading;
    button.classList.toggle('melo-add-to-cart--loading', isLoading);
  }

  function showAddToCartError(form, message) {
    var existing = form.querySelector('.melo-add-to-cart-error');
    if (existing) existing.remove();

    var errorEl = document.createElement('div');
    errorEl.className = 'melo-add-to-cart-error';
    errorEl.textContent = message;
    errorEl.style.color = '#d32f2f';
    errorEl.style.fontSize = '12px';
    errorEl.style.marginTop = '8px';

    var button = form.querySelector('#AddToCart');
    if (button && button.parentNode) {
      button.parentNode.insertBefore(errorEl, button.nextSibling);
    }
  }

  function handleAddToCartClick(event) {
    var button = event.target.closest('#AddToCart');
    if (!button) return;

    var form = button.closest('form') || document.getElementById('AddToCartForm');
    if (!form) return;

    event.preventDefault();

    var formData = new FormData(form);
    packToBoxes(formData);
    setAddToCartLoading(form, true);

    addToCart(formData)
      .then(function () {
        return getCart();
      })
      .then(function (cart) {
        renderCart(cart);
        updateHeaderCartCount(cart.item_count);
        window.MeloCartDrawer && window.MeloCartDrawer.open();
      })
      .catch(function (error) {
        showAddToCartError(form, error.message || 'Could not add item to cart.');
      })
      .then(function () {
        setAddToCartLoading(form, false);
      });
  }

  function handleCartContainerClick(event) {
    var qtyButton = event.target.closest('[data-qty-action]');
    var removeButton = event.target.closest('.melo-cart-item__remove');

    if (qtyButton) {
      var qtyWrap = qtyButton.closest('.melo-cart-item__qty');
      var lineKey = qtyWrap.getAttribute('data-line-key');
      var boxes = parseInt(qtyWrap.getAttribute('data-boxes'), 10) || 1;
      var valueEl = qtyWrap.querySelector('.melo-cart-item__qty-value');
      var currentQty = parseInt(valueEl.textContent, 10) || 0;
      var newQty = qtyButton.getAttribute('data-qty-action') === 'increase'
        ? currentQty + 1
        : currentQty - 1;

      if (newQty < 0) return;

      // +/- steps a whole pack (2 or 4 boxes for the 60/120-strip packs).
      changeLine(lineKey, newQty * boxes).then(function (cart) {
        renderCart(cart);
        updateHeaderCartCount(cart.item_count);
      });

      return;
    }

    if (removeButton) {
      var removeLineKey = removeButton.getAttribute('data-line-key');

      changeLine(removeLineKey, 0).then(function (cart) {
        renderCart(cart);
        updateHeaderCartCount(cart.item_count);
      });
    }
  }

  function handleUpsellClick(event) {
    var upsellButton = event.target.closest('.melo-cart-upsell');
    if (!upsellButton) return;

    var variantId = upsellButton.getAttribute('data-variant-id');
    var boxes = parseInt(upsellButton.getAttribute('data-boxes'), 10) || 1;
    var packName = upsellButton.getAttribute('data-pack');
    var line = { id: variantId, quantity: boxes };

    if (packName) {
      line.properties = { Pack: packName, _boxes: String(boxes) };
    }

    upsellButton.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(line)
    })
      .then(function () { return getCart(); })
      .then(function (cart) {
        renderCart(cart);
        updateHeaderCartCount(cart.item_count);
      });
  }

  function handleHeaderCartClick(event) {
    var trigger = event.target.closest('.melo-cart-pill, .icon-cart-active');
    if (!trigger) return;

    // Runs in the capture phase, before the theme's existing mini-cart
    // dropdown toggle (bound in main.js) gets a chance to run, so we can
    // fully replace that behavior with the same drawer used by Add to Cart.
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    getCart().then(function (cart) {
      renderCart(cart);
      window.MeloCartDrawer && window.MeloCartDrawer.open();
    });
  }

  function init() {
    document.addEventListener('click', handleAddToCartClick);
    document.addEventListener('click', handleHeaderCartClick, true);
    document.addEventListener('click', handleUpsellClick);
    document.addEventListener('click', handleRemoveCodeClick);
    document.addEventListener('submit', handleCodeSubmit);

    var container = document.getElementById('CartContainer');
    if (container) {
      container.addEventListener('click', handleCartContainerClick);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
